/* eslint-disable */
const LangMyAccount = {
	"myAccount._title": ["MY ACCOUNT", "គណនី​ខ្ញុំ"],
	"myAccount.copy._totalStarEarner": ["Total Stars Earned", "ចំនួន​ផ្កាយ​សរុប​"],

	"myAccount.copy._xLevel": ["${tierCode}", "${tierCode}"],
	"myAccount.copy._xLevel_Gold": ["Gold", "មាស"],
	"myAccount.copy._xLevel_Green": ["Green", "បៃតង"],
	"myAccount.copy._xLevel_tier": [" Tier", "ប្រភេទ"],
	"myAccount.copy._anniversaryDate": [
		"Anniversary Date <br /> ${date}",
		"កាល​បរិច្ឆេទ​គម្រប់​ខួប <br /> ${date}",
	],
	"myAccount.copy._xStarsUntilReward": [
		"You are ${stars} Stars away from <span class='color-secondary d-inline-block'>Gold Tier</span>",
		"លោក​អ្នក​​​នៅ​ខ្វះ​​ផ្កាយ​ចំនួន ${stars} ទៀត ដើម្បី​ក្លាយ​ទៅ​ជា <span class='color-secondary d-inline-block'>ប្រភេទ​មាស</span>",
	],
	"myAccount.copy._xStarsUntilFreeDrink": [
		"You are ${stars} Stars away from free drink.",
		"លោក​អ្នក​​​នៅ​ខ្វះ​​ផ្កាយ​ចំនួន ${stars} ទៀត ដើម្បី​ទទួល​បាន ភេសជ្ជៈ​ឥត​គិត​ថ្លៃ",
	],
	"myAccount.copy._xStarsToRetain": [
		"You are ${stars} Stars away to maintain Gold Tier",
		"លោក​អ្នក​​​នៅ​ខ្វះ​​ផ្កាយ​ចំនួន ${stars} ទៀត ដើម្បី​បន្ត​​នៅ​ជា​សមាជិក​មាស",
	],
	"myAccount.copy._extendXLevel": [
		"You are qualified to extend your <span class='color-secondary d-inline-block'>Gold Level</span> for 1 year.",
		"លោក​អ្នក​​​មាន​លក្ខខណ្ឌ​គ្រប់គ្រាន់​ ដើម្បី​បន្ត​​នៅ​ជា​ <span class='color-secondary d-inline-block'> សមាជិក​មាស​​</span>រយៈពេល 1​ឆ្នាំ​ទៀត",
	],
	"myAccount.copy._asOfXDate": ["AS OF ${date}", "ត្រឹម​​ថ្ងៃ​ទី ${date}"],
}

export default LangMyAccount



// WEBPACK FOOTER //
// ./src/resources/modules/LangMyAccount.js